$(function () {
  'use strict'

  /* ==============================================================  /
   *                        Equal body panels
   * ============================================================== */
  let height = 0

  $('.panel-group .panel-body').each(function () {
    if (height < $(this).height()) {
      height = $(this).height()
    }
  })

  $('.panel-group .panel-body').height(height)

})



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/scripts/yumiwi/cards-panels.js